import { render, staticRenderFns } from "./minip-edit.vue?vue&type=template&id=655fe12e&scoped=true"
import script from "./minip-edit.vue?vue&type=script&lang=js"
export * from "./minip-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655fe12e",
  null
  
)

export default component.exports